import { SVGProps } from "react"

import { IconProps } from "../icon.types"

export const IconDashboard = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <DashboardHover {...props} />
  else return <DashboardDefault {...props} />
}

const DashboardDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="dashboard_default_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        ".dashboard_default_svg__st0{fill:none;stroke:currentColor;stroke-width:2}"
      }
    </style>
    <path
      className="dashboard_default_svg__st0"
      d="M24.5 24.3h-8.1c-.4 0-.7-.3-.7-.7v-5.5c0-.4.3-.7.7-.7h8.1c.4 0 .7.3.7.7v5.5c0 .4-.3.7-.7.7zM11 24.3H7.5c-.4 0-.6-.3-.6-.6v-5.4c0-.4.3-.6.6-.6H11c.4 0 .6.3.6.6v5.4c0 .3-.2.6-.6.6zM7.5 6.8h8.1c.4 0 .7.3.7.7V13c0 .4-.3.7-.7.7H7.5c-.4 0-.7-.3-.7-.7V7.5c0-.4.3-.7.7-.7zM21 6.8h3.5c.4 0 .6.3.6.6v5.4c0 .4-.3.6-.6.6H21c-.4 0-.6-.3-.6-.6V7.5c0-.4.2-.7.6-.7z"
    />
  </svg>
)

const DashboardHover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="dashboard_selected_(1)_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {".dashboard_selected_(1)_svg__st0{stroke:currentColor;stroke-width:2}"}
    </style>
    <path
      fill="currentColor"
      className="dashboard_selected_(1)_svg__st0"
      d="M24.5 24.3h-8.1c-.4 0-.7-.3-.7-.7v-5.5c0-.4.3-.7.7-.7h8.1c.4 0 .7.3.7.7v5.5c0 .4-.3.7-.7.7zM11 24.3H7.5c-.4 0-.6-.3-.6-.6v-5.4c0-.4.3-.6.6-.6H11c.4 0 .6.3.6.6v5.4c0 .3-.2.6-.6.6zM7.5 6.8h8.1c.4 0 .7.3.7.7V13c0 .4-.3.7-.7.7H7.5c-.4 0-.7-.3-.7-.7V7.5c0-.4.3-.7.7-.7zM21 6.8h3.5c.4 0 .6.3.6.6v5.4c0 .4-.3.6-.6.6H21c-.4 0-.6-.3-.6-.6V7.5c0-.4.2-.7.6-.7z"
    />
  </svg>
)
